namespace SP {
    export interface ShipmentLineData {
        id: string,
        type: ShipmentLineDataType,
        value: string
    }

}